// US States data — auto-generated.
// Includes capitals, state outline paths (Albers projection), OpenEd flag,
// and stylized flag palettes used as placeholders until real flag SVGs are downloaded.
// Run `node scripts/download-flags.js` to fetch real flag SVGs from Wikimedia Commons.

export const STATES = [
  {
    name: "Alabama",
    abbr: "AL",
    capital: "Montgomery",
    bird: "Yellowhammer",
    flower: "Camellia",
    statehoodYear: 1819,
    nickname: "Yellowhammer State",
    isOpenEd: false,
    flagPalette: ["#FFFFFF", "#C8102E"],
    path: "M648.0,492.4L652.9,491.8L648.0,492.4ZM641.6,384.0L689.2,379.7L702.5,427.0L709.6,439.9L706.7,443.2L705.9,450.1L710.8,468.8L660.7,474.0L660.3,477.0L665.4,481.9L664.7,489.5L655.2,492.0L659.1,490.2L653.4,481.7L651.6,490.2L646.5,489.5L642.2,455.0L643.7,386.2L641.6,384.0Z",
  },
  {
    name: "Alaska",
    abbr: "AK",
    capital: "Juneau",
    bird: "Willow Ptarmigan",
    flower: "Forget-me-not",
    statehoodYear: 1959,
    nickname: "The Last Frontier",
    isOpenEd: false,
    flagPalette: ["#0033A0", "#FFD700"],
    path: "M99.1,569.9L103.4,565.2L102.9,567.5L105.0,567.5L99.1,569.9ZM95.1,582.0L96.9,582.3L95.1,582.0ZM93.3,575.4L95.7,573.1L97.1,574.4L99.0,570.7L103.1,570.6L104.5,573.3L96.0,580.4L97.5,577.1L95.4,579.6L93.3,575.4ZM93.1,582.8L95.0,581.9L93.1,582.8ZM68.2,593.5L70.3,591.7L68.2,593.5ZM65.8,590.1L68.2,590.1L67.1,591.8L65.8,590.1ZM67.5,564.2L69.3,562.5L67.5,564.2ZM56.0,595.9L58.1,596.7L56.0,595.9ZM40.6,595.9L42.5,596.7L40.6,595.9ZM44.2,547.5L49.5,546.7L51.0,551.2L48.4,552.0L44.2,547.5ZM31.3,600.8L36.7,599.1L36.1,596.7L40.1,598.2L36.6,600.9L31.3,600.8ZM50.7,504.5L63.9,499.5L65.7,499.7L65.2,503.9L74.3,503.7L69.7,498.2L72.6,501.9L73.2,497.6L66.5,495.6L66.2,492.3L59.4,484.4L61.5,480.8L69.5,480.0L75.3,471.4L86.7,468.1L89.3,465.1L92.5,466.1L91.5,468.6L94.0,466.3L96.2,469.2L101.4,468.7L102.4,471.8L108.9,470.8L121.6,473.8L126.0,471.7L132.9,474.4L147.3,547.1L154.5,545.1L163.6,554.8L169.4,545.9L180.8,553.8L191.6,565.6L200.1,566.6L202.9,572.6L201.4,577.9L197.6,570.6L198.1,575.1L194.4,573.7L194.1,570.7L192.8,573.7L192.2,568.8L191.1,571.8L189.2,570.5L190.4,567.2L183.2,563.5L181.4,559.6L183.6,560.0L178.4,555.8L176.2,556.8L170.3,549.6L174.7,557.7L167.1,553.4L165.7,554.3L170.3,557.4L168.0,559.3L153.0,552.1L153.4,547.9L151.0,551.3L140.6,550.0L134.0,553.4L135.8,551.2L132.3,548.5L130.8,549.7L128.8,547.8L125.3,550.6L128.4,547.8L123.1,544.2L119.2,547.1L119.0,545.0L120.3,553.9L118.9,552.4L114.9,555.0L114.7,552.9L113.7,556.8L112.5,555.7L111.3,558.7L110.5,557.4L105.8,561.0L105.2,559.0L108.7,555.9L105.2,556.2L106.7,548.5L110.5,545.8L115.5,546.8L111.6,544.8L113.2,542.0L106.3,546.2L100.5,556.9L96.2,559.5L96.0,562.3L99.6,563.5L95.8,569.3L88.0,573.7L85.6,578.3L77.7,581.9L76.7,585.8L64.1,589.7L62.6,587.5L60.6,591.3L57.8,589.3L57.7,592.0L54.8,591.0L55.2,594.1L46.7,594.8L48.6,591.6L54.2,592.2L62.0,585.2L66.5,584.6L66.3,586.9L68.7,586.9L68.6,583.0L76.4,579.3L80.9,573.4L84.4,563.1L79.6,565.0L78.4,561.8L76.4,566.6L71.0,560.7L64.7,564.1L65.8,556.7L63.8,551.1L56.6,552.7L52.6,546.7L54.7,542.9L51.1,538.2L51.8,535.9L59.6,526.0L64.3,527.9L67.5,524.9L71.5,525.2L73.0,523.2L71.0,517.8L73.7,515.7L72.5,514.0L66.5,518.0L65.6,515.4L55.2,514.1L53.9,509.4L55.9,508.7L50.7,504.5ZM24.9,603.0L31.9,599.3L24.9,603.0ZM34.4,517.8L35.3,516.1L39.4,517.9L44.8,522.4L40.8,524.5L34.4,517.8ZM7.0,603.0L8.6,602.9L7.0,603.0ZM23.4,539.9L26.2,542.3L23.4,539.9ZM-0.0,602.3L5.0,604.1L-0.0,602.3ZM-6.2,601.2L0.7,600.9L-2.0,602.5L-6.2,601.2ZM-15.0,601.4L-13.1,599.3L-11.1,600.8L-15.0,601.4ZM-18.1,599.6L-14.6,599.3L-18.1,599.6ZM-20.1,597.5L-19.5,600.0L-20.1,597.5ZM-35.2,593.3L-33.1,596.2L-35.2,593.3ZM-40.8,588.6L-38.1,588.3L-40.8,588.6ZM-55.8,576.6L-54.4,577.8L-55.8,576.6ZM-57.6,570.9L-53.9,573.8L-57.6,570.9ZM196.5,577.0L196.2,575.0L196.5,577.0ZM194.7,574.9L195.8,576.5L194.7,574.9ZM187.1,569.1L188.9,568.2L187.1,569.1ZM186.2,576.9L188.2,576.0L186.2,576.9ZM184.9,573.1L186.8,569.5L194.4,575.9L195.7,580.1L189.6,577.5L192.0,581.3L184.9,573.1ZM180.3,567.2L185.4,564.3L188.7,566.7L183.9,568.5L183.4,573.2L180.3,567.2ZM174.6,555.9L180.2,559.2L181.4,562.6L179.6,565.9L174.6,555.9ZM173.9,564.8L177.2,563.4L180.8,572.7L173.9,564.8ZM173.5,565.9L174.9,567.4L173.5,565.9ZM169.1,561.4L169.1,558.6L171.5,557.8L175.3,558.7L177.1,562.7L173.7,562.2L173.0,564.7L169.1,561.4ZM120.8,555.1L123.6,550.0L120.8,555.1ZM120.4,551.4L121.6,548.6L120.4,551.4Z",
  },
  {
    name: "Arizona",
    abbr: "AZ",
    capital: "Phoenix",
    bird: "Cactus Wren",
    flower: "Saguaro Cactus Blossom",
    statehoodYear: 1912,
    nickname: "Grand Canyon State",
    isOpenEd: false,
    flagPalette: ["#CE1126", "#FFD700", "#003F87"],
    path: "M145.1,407.0L150.3,405.1L150.2,400.8L147.0,398.6L147.5,393.9L152.4,389.1L153.9,380.5L162.8,373.6L158.9,369.3L156.2,359.1L158.7,352.8L159.5,331.4L166.6,331.5L170.0,334.9L172.6,331.5L176.0,313.3L264.6,328.0L246.8,456.3L208.2,450.5L142.3,411.7L145.1,407.0Z",
  },
  {
    name: "Arkansas",
    abbr: "AR",
    capital: "Little Rock",
    bird: "Northern Mockingbird",
    flower: "Apple Blossom",
    statehoodYear: 1836,
    nickname: "The Natural State",
    isOpenEd: true,
    flagPalette: ["#C8102E", "#FFFFFF", "#003F87"],
    path: "M523.0,355.3L603.6,352.2L605.2,357.3L600.2,364.0L611.9,363.1L613.7,365.2L608.4,369.4L609.2,374.5L607.0,373.8L606.9,377.1L604.8,376.8L607.1,383.2L603.1,385.7L604.0,388.7L599.8,389.5L598.6,400.4L592.3,405.2L594.5,405.8L592.0,407.0L593.4,409.4L589.7,410.8L591.8,415.1L588.9,416.6L591.1,417.7L587.4,417.8L589.3,419.6L587.6,423.2L590.9,423.3L589.4,433.1L535.0,434.7L534.8,422.5L528.8,422.8L526.4,420.7L526.8,380.5L523.0,355.3Z",
  },
  {
    name: "California",
    abbr: "CA",
    capital: "Sacramento",
    bird: "California Quail",
    flower: "California Poppy",
    statehoodYear: 1850,
    nickname: "The Golden State",
    isOpenEd: false,
    flagPalette: ["#FFFFFF", "#C8102E", "#8B4513"],
    path: "M77.2,374.3L81.3,379.5L77.2,374.3ZM74.7,384.2L78.3,390.0L74.7,384.2ZM58.3,374.3L60.7,376.1L58.3,374.3ZM56.6,355.0L63.6,357.8L59.5,358.6L56.6,355.0ZM50.3,355.2L54.1,355.4L54.9,357.8L51.9,358.1L50.3,355.2ZM46.8,353.4L49.4,354.4L46.8,353.4ZM32.6,160.0L100.5,179.2L83.3,245.5L156.8,356.2L158.9,369.3L162.8,373.6L153.9,380.5L152.4,389.1L148.0,391.7L147.0,398.6L150.7,403.8L148.8,406.9L99.5,401.7L96.5,382.3L87.9,371.0L82.1,369.3L81.7,362.5L71.0,358.1L65.0,349.3L48.8,344.3L46.5,340.5L49.8,328.1L46.4,325.7L46.9,320.1L41.6,313.3L34.8,296.1L35.1,289.9L38.1,289.0L39.2,282.7L35.1,281.0L31.4,274.3L33.3,260.8L35.3,260.7L34.7,265.7L39.3,270.3L35.8,257.2L38.9,254.7L35.7,253.7L33.2,259.9L26.2,253.5L28.5,247.8L20.1,229.8L24.0,209.2L18.5,197.2L18.9,193.1L27.7,181.7L31.3,172.9L30.4,164.4L32.6,160.0Z",
  },
  {
    name: "Colorado",
    abbr: "CO",
    capital: "Denver",
    bird: "Lark Bunting",
    flower: "Rocky Mountain Columbine",
    statehoodYear: 1876,
    nickname: "The Centennial State",
    isOpenEd: true,
    flagPalette: ["#003F87", "#FFFFFF", "#C8102E", "#FFD700"],
    path: "M277.1,237.2L395.3,249.0L389.7,340.7L264.6,328.0L277.1,237.2Z",
  },
  {
    name: "Connecticut",
    abbr: "CT",
    capital: "Hartford",
    bird: "American Robin",
    flower: "Mountain Laurel",
    statehoodYear: 1788,
    nickname: "The Constitution State",
    isOpenEd: false,
    flagPalette: ["#003F87", "#FFFFFF"],
    path: "M871.2,184.0L898.7,177.7L902.1,192.8L884.7,198.4L874.1,208.3L872.3,206.0L875.7,202.6L871.2,184.0Z",
  },
  {
    name: "Delaware",
    abbr: "DE",
    capital: "Dover",
    bird: "Blue Hen Chicken",
    flower: "Peach Blossom",
    statehoodYear: 1787,
    nickname: "The First State",
    isOpenEd: false,
    flagPalette: ["#FFD700", "#003F87"],
    path: "M844.9,244.6L846.5,241.9L850.8,241.4L849.3,249.3L856.8,260.7L861.3,262.7L863.7,270.3L852.6,272.5L844.9,244.6Z",
  },
  {
    name: "Florida",
    abbr: "FL",
    capital: "Tallahassee",
    bird: "Northern Mockingbird",
    flower: "Orange Blossom",
    statehoodYear: 1845,
    nickname: "The Sunshine State",
    isOpenEd: false,
    flagPalette: ["#FFFFFF", "#C8102E"],
    path: "M814.6,594.5L815.5,593.1L814.6,594.5ZM807.4,599.0L811.5,597.2L807.4,599.0ZM793.7,604.2L800.5,597.7L805.1,600.1L793.7,604.2ZM789.6,605.4L792.1,604.4L789.6,605.4ZM777.4,558.3L779.8,562.4L783.3,563.1L779.5,562.7L777.4,558.3ZM720.4,495.2L722.4,494.1L720.4,495.2ZM710.8,468.8L714.2,475.0L765.8,471.5L767.3,476.0L769.7,475.6L770.0,464.9L780.5,466.3L787.0,486.3L804.6,511.0L806.6,521.9L822.1,549.0L823.8,574.5L821.8,573.7L820.9,583.7L824.0,577.8L823.8,580.3L816.4,593.2L819.7,586.1L805.5,588.9L800.6,577.8L791.9,575.4L786.5,564.2L783.0,561.3L781.4,562.6L779.2,558.4L781.0,558.5L780.4,552.0L777.3,557.8L765.2,540.9L767.0,541.0L770.6,531.9L767.9,533.5L767.6,530.8L764.7,529.8L767.4,534.3L765.1,539.2L761.9,533.4L760.7,526.1L762.7,529.5L763.6,520.7L761.9,510.2L758.9,505.1L754.0,506.1L739.3,489.9L732.2,486.7L727.4,487.4L726.4,492.2L711.8,498.0L714.2,499.9L720.1,496.0L713.7,500.8L707.4,499.8L705.7,493.6L688.8,486.2L678.4,486.1L663.7,490.1L666.3,486.4L665.1,480.9L660.3,477.0L660.7,474.0L710.8,468.8Z",
  },
  {
    name: "Georgia",
    abbr: "GA",
    capital: "Atlanta",
    bird: "Brown Thrasher",
    flower: "Cherokee Rose",
    statehoodYear: 1788,
    nickname: "The Peach State",
    isOpenEd: false,
    flagPalette: ["#C8102E", "#FFFFFF", "#003F87"],
    path: "M689.2,379.7L734.9,373.7L731.7,381.5L741.1,385.4L748.3,396.2L771.3,414.4L774.0,422.7L778.7,425.8L781.4,433.4L786.9,434.7L781.4,442.3L782.9,444.6L780.7,447.0L782.4,447.1L781.3,454.4L778.3,460.2L779.9,459.9L780.1,466.1L770.0,464.9L769.7,475.6L767.3,476.0L765.8,471.5L713.2,474.2L708.3,464.8L708.6,457.1L705.9,450.1L706.7,443.2L709.6,439.9L702.5,427.0L689.2,379.7Z",
  },
  {
    name: "Hawaii",
    abbr: "HI",
    capital: "Honolulu",
    bird: "Nene",
    flower: "Yellow Hibiscus",
    statehoodYear: 1959,
    nickname: "The Aloha State",
    isOpenEd: false,
    flagPalette: ["#003F87", "#FFFFFF", "#C8102E"],
    path: "M305.4,584.5L310.2,579.2L309.7,572.5L322.2,578.3L331.9,590.3L317.3,598.1L313.8,603.1L308.4,598.5L309.1,593.7L305.4,584.5ZM291.6,557.9L293.9,555.4L296.4,558.5L301.6,557.7L306.8,562.4L298.5,565.6L296.7,561.1L291.6,557.9ZM291.6,566.7L295.0,565.6L291.6,566.7ZM283.9,558.3L287.4,558.0L289.3,560.4L285.9,562.1L283.9,558.3ZM278.6,553.8L279.6,551.2L291.4,552.6L287.8,555.0L278.6,553.8ZM258.1,543.0L264.7,540.0L271.4,549.4L261.5,549.3L258.1,543.0ZM226.1,532.6L231.0,528.2L236.6,530.2L233.3,536.3L226.1,532.6ZM216.3,536.6L220.0,533.2L217.1,538.2L216.3,536.6Z",
  },
  {
    name: "Idaho",
    abbr: "ID",
    capital: "Boise",
    bird: "Mountain Bluebird",
    flower: "Syringa",
    statehoodYear: 1890,
    nickname: "The Gem State",
    isOpenEd: false,
    flagPalette: ["#003F87", "#FFD700"],
    path: "M170.5,102.4L170.1,94.1L183.6,35.9L198.1,39.0L193.3,61.5L196.8,68.7L197.0,74.2L195.3,74.3L200.8,79.7L206.8,93.8L213.4,96.3L205.2,119.7L208.1,122.6L214.6,118.2L216.9,121.0L219.4,138.5L224.1,141.5L227.0,151.6L228.5,149.0L234.6,150.9L236.7,148.5L249.1,151.2L251.5,146.7L256.0,153.9L247.2,209.6L148.9,190.7L157.9,150.5L161.7,143.3L157.4,136.6L175.7,112.3L170.5,102.4Z",
  },
  {
    name: "Illinois",
    abbr: "IL",
    capital: "Springfield",
    bird: "Northern Cardinal",
    flower: "Violet",
    statehoodYear: 1818,
    nickname: "The Prairie State",
    isOpenEd: false,
    flagPalette: ["#FFFFFF", "#003F87"],
    path: "M576.5,264.7L576.5,260.9L581.2,257.8L583.6,251.8L583.7,247.9L580.7,244.7L581.6,240.8L591.3,237.7L595.5,231.0L595.5,223.8L587.0,215.4L634.2,212.4L634.0,216.8L640.3,229.8L645.0,283.6L643.5,287.9L646.8,296.6L639.4,310.3L639.4,319.7L637.3,323.1L639.0,327.3L632.2,329.8L633.1,336.9L624.4,334.1L620.6,337.5L621.2,339.9L616.7,338.9L613.8,333.4L615.4,331.0L613.3,324.3L597.6,313.2L601.0,298.4L594.9,296.1L592.7,298.5L589.7,289.9L578.1,279.5L575.2,270.5L576.5,264.7Z",
  },
  {
    name: "Indiana",
    abbr: "IN",
    capital: "Indianapolis",
    bird: "Northern Cardinal",
    flower: "Peony",
    statehoodYear: 1816,
    nickname: "The Hoosier State",
    isOpenEd: true,
    flagPalette: ["#003F87", "#FFD700"],
    path: "M640.3,229.8L644.9,231.4L651.9,227.6L685.6,223.9L691.3,285.7L693.7,289.3L693.5,291.6L687.5,294.5L682.9,294.1L683.6,298.2L677.1,305.1L674.1,312.8L668.2,307.9L664.4,316.1L659.7,313.6L655.3,318.7L646.7,315.0L646.7,318.3L641.3,316.7L640.9,320.2L638.0,317.4L639.4,310.3L646.8,296.6L643.5,287.9L645.0,283.6L640.3,229.8Z",
  },
  {
    name: "Iowa",
    abbr: "IA",
    capital: "Des Moines",
    bird: "American Goldfinch",
    flower: "Wild Prairie Rose",
    statehoodYear: 1846,
    nickname: "The Hawkeye State",
    isOpenEd: true,
    flagPalette: ["#003F87", "#FFFFFF", "#C8102E"],
    path: "M490.6,195.2L576.3,193.3L579.2,198.7L577.4,201.6L579.9,210.5L585.6,212.4L595.5,223.8L595.5,231.0L591.3,237.7L581.6,240.8L580.7,244.7L583.7,247.9L583.6,251.8L581.2,257.8L576.5,260.9L576.5,264.7L570.9,259.6L502.0,261.9L495.9,230.2L487.6,213.3L490.8,203.9L488.2,195.2L490.6,195.2Z",
  },
  {
    name: "Kansas",
    abbr: "KS",
    capital: "Topeka",
    bird: "Western Meadowlark",
    flower: "Sunflower",
    statehoodYear: 1861,
    nickname: "The Sunflower State",
    isOpenEd: true,
    flagPalette: ["#003F87", "#FFD700"],
    path: "M393.9,271.9L509.9,275.2L513.1,278.1L516.5,277.7L517.3,281.4L513.5,285.8L518.5,293.2L522.6,294.4L522.8,343.8L389.7,340.7L393.9,271.9Z",
  },
  {
    name: "Kentucky",
    abbr: "KY",
    capital: "Frankfort",
    bird: "Northern Cardinal",
    flower: "Goldenrod",
    statehoodYear: 1792,
    nickname: "The Bluegrass State",
    isOpenEd: false,
    flagPalette: ["#003F87", "#FFD700"],
    path: "M621.2,339.9L623.1,334.2L633.1,336.9L632.2,329.8L639.0,327.3L637.3,323.1L641.5,319.4L641.3,316.7L646.7,318.3L646.7,315.0L655.3,318.7L660.8,313.4L664.4,316.1L668.2,307.9L674.1,312.8L677.1,305.1L683.6,298.2L682.9,294.1L693.5,291.6L691.3,285.7L693.7,283.2L698.5,283.2L703.9,289.8L713.9,292.7L716.2,290.6L720.6,292.4L727.0,287.9L728.4,291.7L732.8,293.7L733.2,300.7L736.4,305.6L740.9,311.1L747.1,313.2L735.2,324.6L729.0,334.2L719.6,339.2L640.8,345.4L641.4,349.5L616.9,351.3L617.4,348.6L620.2,349.5L621.2,347.2L621.2,339.9ZM615.6,351.5L614.4,349.7L615.6,351.5Z",
  },
  {
    name: "Louisiana",
    abbr: "LA",
    capital: "Baton Rouge",
    bird: "Brown Pelican",
    flower: "Magnolia",
    statehoodYear: 1812,
    nickname: "The Pelican State",
    isOpenEd: false,
    flagPalette: ["#003F87", "#FFFFFF"],
    path: "M637.5,497.4L638.2,504.0L637.5,497.4ZM628.5,497.9L631.3,495.4L630.8,499.1L628.5,497.9ZM609.5,520.8L611.0,521.4L609.5,520.8ZM606.0,521.3L608.7,521.8L606.0,521.3ZM602.2,522.4L604.1,522.2L602.2,522.4ZM576.5,511.5L582.6,512.0L580.0,513.9L576.5,511.5ZM535.0,434.7L589.4,433.1L589.8,435.4L590.9,433.6L590.1,441.4L592.5,441.1L593.4,444.5L590.9,444.9L595.4,448.2L590.4,451.5L593.4,452.2L590.6,454.6L592.3,455.5L587.4,459.5L587.0,461.4L589.0,461.4L586.5,464.8L584.2,465.1L586.4,466.0L584.4,467.0L585.3,470.7L583.3,470.0L584.6,472.8L582.2,473.1L582.6,479.2L619.6,477.2L617.6,484.9L624.8,495.4L618.5,499.8L621.9,502.7L625.7,497.6L628.2,501.3L631.1,499.7L628.0,503.0L629.7,504.7L628.1,504.1L626.7,507.3L625.4,505.7L622.5,509.6L626.3,513.4L636.1,516.6L634.2,521.8L631.8,519.9L628.8,523.6L631.1,517.7L628.6,519.1L619.8,515.3L612.6,521.1L608.1,515.4L599.9,522.5L597.9,519.8L591.5,518.6L591.6,516.0L594.6,518.3L594.3,516.3L592.5,514.3L590.2,515.4L589.6,512.7L587.7,513.7L583.8,510.2L584.2,507.9L579.1,508.6L580.0,505.9L572.8,507.9L576.1,511.6L570.6,513.1L553.6,508.2L540.6,510.4L538.9,507.5L543.1,502.1L542.1,491.0L546.1,479.9L539.6,467.0L539.8,463.0L535.5,457.9L535.0,434.7Z",
  },
  {
    name: "Maine",
    abbr: "ME",
    capital: "Augusta",
    bird: "Black-capped Chickadee",
    flower: "White Pine Cone & Tassel",
    statehoodYear: 1820,
    nickname: "The Pine Tree State",
    isOpenEd: false,
    flagPalette: ["#003F87", "#FFD700"],
    path: "M938.0,116.1L937.9,114.5L939.8,115.7L938.0,116.1ZM931.4,119.2L932.7,117.1L934.3,119.4L933.0,120.8L931.4,119.2ZM930.1,116.3L931.0,113.3L930.1,116.3ZM910.2,150.1L903.6,143.5L890.9,102.4L894.8,103.1L894.3,99.3L897.3,98.8L895.2,96.3L900.0,86.1L897.7,79.7L899.9,73.8L899.1,67.5L905.9,47.6L908.8,47.5L912.5,52.3L919.7,45.9L922.6,45.8L929.7,49.7L938.7,79.9L944.6,79.9L946.1,87.0L949.5,89.7L952.0,88.1L957.1,94.8L955.0,99.4L951.5,99.6L950.2,105.6L946.8,104.3L943.8,110.3L941.4,109.7L942.2,113.0L938.9,113.7L938.1,109.7L935.4,111.3L937.3,119.8L934.5,114.7L931.9,114.3L931.0,110.1L928.5,112.6L930.2,122.9L927.1,126.5L924.8,124.8L924.4,127.8L915.1,134.1L910.2,150.1Z",
  },
  {
    name: "Maryland",
    abbr: "MD",
    capital: "Annapolis",
    bird: "Baltimore Oriole",
    flower: "Black-eyed Susan",
    statehoodYear: 1788,
    nickname: "The Old Line State",
    isOpenEd: false,
    flagPalette: ["#FFD700", "#000000", "#C8102E", "#FFFFFF"],
    path: "M849.9,285.0L848.6,283.4L849.9,285.0ZM847.3,281.5L847.7,279.6L849.0,282.2L847.3,281.5ZM782.3,256.9L844.9,244.6L852.6,272.5L863.7,270.3L862.5,280.5L851.6,285.3L850.2,275.4L848.9,278.3L847.7,275.6L846.1,279.2L841.4,274.1L842.5,270.7L846.4,271.3L841.6,268.4L840.3,269.8L841.6,263.9L839.0,266.3L839.4,261.7L841.9,262.2L839.3,259.3L840.2,254.7L842.9,253.3L842.6,248.9L839.2,254.5L838.3,252.4L838.5,255.8L836.8,254.0L836.3,258.8L833.5,257.8L838.0,262.7L836.2,268.8L843.8,284.2L834.6,281.5L833.0,279.0L833.8,281.3L832.2,280.7L829.9,277.6L826.1,279.8L825.6,276.0L829.7,267.2L819.4,265.0L818.7,261.5L813.2,260.2L810.8,254.4L804.5,253.4L798.6,258.6L794.2,256.7L792.3,261.6L789.7,261.4L784.1,268.5L782.3,256.9Z",
  },
  {
    name: "Massachusetts",
    abbr: "MA",
    capital: "Boston",
    bird: "Black-capped Chickadee",
    flower: "Mayflower",
    statehoodYear: 1788,
    nickname: "The Bay State",
    isOpenEd: false,
    flagPalette: ["#FFFFFF", "#003F87"],
    path: "M927.7,186.8L931.5,184.3L933.0,186.0L927.7,186.8ZM918.3,188.3L921.3,184.4L924.2,185.1L924.6,186.7L918.3,188.3ZM871.0,167.6L902.9,160.7L909.5,154.8L911.2,158.5L914.3,158.4L910.6,162.2L910.0,168.6L915.0,169.0L916.4,173.3L921.7,177.7L928.8,175.1L926.2,170.0L923.6,170.0L926.7,169.7L930.9,178.5L924.7,179.9L916.1,187.6L920.0,183.3L919.6,179.8L912.8,186.4L905.5,176.0L871.2,184.0L871.0,167.6Z",
  },
  {
    name: "Michigan",
    abbr: "MI",
    capital: "Lansing",
    bird: "American Robin",
    flower: "Apple Blossom",
    statehoodYear: 1837,
    nickname: "The Great Lakes State",
    isOpenEd: false,
    flagPalette: ["#003F87", "#FFD700"],
    path: "M677.1,130.8L682.0,132.3L679.8,133.4L677.1,130.8ZM663.5,133.2L664.6,134.5L663.5,133.2ZM662.4,138.6L664.0,134.8L664.5,138.1L662.4,138.6ZM658.8,142.5L659.7,143.9L658.8,142.5ZM656.6,149.6L658.2,151.3L656.6,149.6ZM645.5,139.9L646.4,141.5L645.5,139.9ZM651.9,227.6L659.8,210.2L659.4,200.2L652.4,184.3L653.8,180.1L651.9,174.9L657.1,154.9L661.1,153.5L664.8,147.2L663.9,155.9L665.0,157.2L666.3,152.0L666.1,157.6L667.3,145.5L674.2,141.9L670.5,138.3L671.7,133.8L675.4,132.7L696.7,139.9L701.3,147.0L698.4,147.2L702.2,153.9L702.4,162.5L699.8,164.4L699.2,169.4L694.4,173.2L694.1,177.1L699.0,180.2L702.4,172.1L709.9,167.7L713.0,169.1L721.5,191.2L720.9,199.8L718.5,202.2L719.1,198.7L716.3,199.4L708.3,221.7L651.9,227.6ZM601.4,92.4L613.6,84.4L606.6,91.7L601.4,92.4ZM585.3,123.1L606.9,111.9L618.6,100.5L624.4,99.7L625.9,101.1L622.2,101.8L615.4,111.8L615.6,116.6L620.1,111.5L618.2,114.7L624.0,112.5L628.3,114.3L633.1,120.8L638.5,119.7L641.8,121.6L651.8,115.2L670.0,111.0L669.8,117.6L676.5,118.3L683.4,114.8L684.4,121.5L682.5,123.0L689.0,126.3L689.4,123.8L692.3,123.4L695.2,125.8L694.0,127.6L681.2,128.8L676.5,126.6L675.7,131.6L671.2,128.3L662.9,127.3L660.4,130.5L651.3,131.9L646.8,140.0L645.0,138.4L647.3,133.5L643.6,134.5L641.4,138.5L639.9,135.4L632.4,153.0L629.9,151.5L630.2,146.5L627.3,147.0L628.2,140.2L623.1,138.1L622.7,135.0L590.3,128.0L585.3,123.1Z",
  },
  {
    name: "Minnesota",
    abbr: "MN",
    capital: "Saint Paul",
    bird: "Common Loon",
    flower: "Pink and White Lady's Slipper",
    statehoodYear: 1858,
    nickname: "The North Star State",
    isOpenEd: true,
    flagPalette: ["#003F87", "#FFFFFF"],
    path: "M479.5,70.7L510.8,70.8L510.7,62.2L513.7,62.5L518.6,76.5L530.7,78.8L531.5,81.3L543.7,78.5L549.1,80.2L548.0,82.0L551.1,82.2L553.4,87.3L554.9,84.2L558.1,84.0L565.8,90.7L576.0,85.7L578.1,88.9L597.6,89.5L579.0,99.5L558.9,119.4L560.2,121.1L555.9,122.3L556.4,135.6L547.6,144.0L547.5,147.3L551.3,149.9L549.3,165.9L572.3,182.2L576.3,193.3L490.6,195.2L490.8,154.3L484.4,147.3L488.8,142.5L489.3,136.5L485.5,123.3L484.9,102.5L480.5,89.4L481.4,77.7L479.5,70.7Z",
  },
  {
    name: "Mississippi",
    abbr: "MS",
    capital: "Jackson",
    bird: "Northern Mockingbird",
    flower: "Magnolia",
    statehoodYear: 1817,
    nickname: "The Magnolia State",
    isOpenEd: false,
    flagPalette: ["#C8102E", "#FFFFFF", "#003F87"],
    path: "M644.5,493.1L646.5,492.9L644.5,493.1ZM639.3,492.9L643.0,493.2L639.3,492.9ZM635.2,493.9L637.0,493.5L635.2,493.9ZM589.4,433.1L590.9,423.3L587.6,423.2L589.3,419.6L587.4,417.8L591.1,417.7L588.9,416.6L591.8,415.1L589.7,410.8L593.4,409.4L592.0,407.0L594.5,405.8L592.3,405.2L598.6,400.4L599.8,389.5L604.0,388.7L602.8,386.7L641.6,384.0L643.7,386.2L642.2,455.0L646.5,489.5L629.1,492.3L628.5,490.7L626.2,495.2L623.9,495.5L617.6,484.9L619.6,477.2L582.6,479.2L582.2,473.1L584.6,472.8L583.3,470.0L585.3,470.7L584.4,467.0L586.4,466.0L584.2,465.1L586.5,464.8L589.0,461.4L587.0,461.4L587.4,459.5L592.3,455.5L590.6,454.6L593.4,452.2L590.4,451.5L595.4,448.2L590.9,444.9L593.4,444.5L592.5,441.1L590.1,441.4L591.8,439.3L589.8,439.0L591.3,435.6L590.9,433.6L588.6,434.8L589.4,433.1Z",
  },
  {
    name: "Missouri",
    abbr: "MO",
    capital: "Jefferson City",
    bird: "Eastern Bluebird",
    flower: "Hawthorn",
    statehoodYear: 1821,
    nickname: "The Show Me State",
    isOpenEd: false,
    flagPalette: ["#C8102E", "#FFFFFF", "#003F87"],
    path: "M502.0,261.9L570.9,259.6L572.8,261.1L576.5,264.7L575.2,270.5L578.1,279.5L589.7,289.9L591.3,297.3L593.4,298.3L594.9,296.1L601.0,298.4L597.6,313.2L613.3,324.3L615.4,331.0L613.8,333.4L616.7,338.9L621.8,340.3L620.2,349.5L617.4,348.6L616.3,352.2L614.0,350.3L615.1,356.7L612.1,357.7L614.2,360.1L612.4,363.1L600.2,364.0L605.2,357.3L603.6,352.2L523.0,355.3L522.6,294.4L518.5,293.2L513.5,285.8L517.3,281.4L516.5,277.7L513.1,278.1L508.2,274.5L502.0,261.9Z",
  },
  {
    name: "Montana",
    abbr: "MT",
    capital: "Helena",
    bird: "Western Meadowlark",
    flower: "Bitterroot",
    statehoodYear: 1889,
    nickname: "The Treasure State",
    isOpenEd: true,
    flagPalette: ["#003F87", "#FFD700"],
    path: "M198.1,39.0L284.5,54.8L376.9,65.7L369.4,155.7L257.8,142.0L256.0,153.9L251.5,146.7L249.1,151.2L236.7,148.5L234.6,150.9L228.5,149.0L227.0,151.6L224.1,141.5L219.4,138.5L216.9,121.0L214.6,118.2L208.1,122.6L205.2,119.7L213.4,96.3L206.8,93.8L200.8,79.7L195.3,74.3L197.0,74.2L196.8,68.7L193.3,61.5L198.1,39.0Z",
  },
  {
    name: "Nebraska",
    abbr: "NE",
    capital: "Lincoln",
    bird: "Western Meadowlark",
    flower: "Goldenrod",
    statehoodYear: 1867,
    nickname: "The Cornhusker State",
    isOpenEd: false,
    flagPalette: ["#003F87", "#FFD700"],
    path: "M365.3,201.0L456.8,206.2L464.3,211.7L467.8,209.4L476.4,209.5L484.7,213.4L488.0,217.9L491.4,218.4L492.3,225.8L496.9,234.0L496.4,239.9L500.1,245.2L499.9,258.5L509.9,275.2L393.9,271.9L395.3,249.0L361.4,246.5L365.3,201.0Z",
  },
  {
    name: "Nevada",
    abbr: "NV",
    capital: "Carson City",
    bird: "Mountain Bluebird",
    flower: "Sagebrush",
    statehoodYear: 1864,
    nickname: "The Silver State",
    isOpenEd: true,
    flagPalette: ["#003F87", "#FFD700", "#9CA9B7"],
    path: "M100.5,179.2L197.7,201.1L172.6,331.5L170.0,334.9L166.6,331.5L159.5,331.4L156.8,356.2L83.3,245.5L100.5,179.2Z",
  },
  {
    name: "New Hampshire",
    abbr: "NH",
    capital: "Concord",
    bird: "Purple Finch",
    flower: "Purple Lilac",
    statehoodYear: 1788,
    nickname: "The Granite State",
    isOpenEd: false,
    flagPalette: ["#003F87", "#FFD700"],
    path: "M886.1,110.5L885.8,105.4L890.9,102.4L903.6,143.5L910.2,150.1L909.5,154.8L902.9,160.7L884.1,164.8L881.7,161.7L880.6,145.8L883.1,133.0L881.8,127.9L887.9,122.1L886.1,110.5Z",
  },
  {
    name: "New Jersey",
    abbr: "NJ",
    capital: "Trenton",
    bird: "American Goldfinch",
    flower: "Common Meadow Violet",
    statehoodYear: 1787,
    nickname: "The Garden State",
    isOpenEd: false,
    flagPalette: ["#D9B97D", "#003F87"],
    path: "M849.2,245.8L860.6,230.8L849.9,220.8L851.5,216.1L849.6,213.8L853.2,205.9L855.0,204.0L870.1,209.0L866.6,221.4L871.5,221.5L873.2,237.3L864.4,258.6L862.6,259.0L862.9,253.8L858.6,254.3L850.4,249.5L849.2,245.8Z",
  },
  {
    name: "New Mexico",
    abbr: "NM",
    capital: "Santa Fe",
    bird: "Greater Roadrunner",
    flower: "Yucca Flower",
    statehoodYear: 1912,
    nickname: "The Land of Enchantment",
    isOpenEd: false,
    flagPalette: ["#FFD700", "#C8102E"],
    path: "M264.6,328.0L372.5,339.4L362.9,453.3L295.1,447.0L296.3,452.1L264.2,448.2L262.9,458.4L246.8,456.3L264.6,328.0Z",
  },
  {
    name: "New York",
    abbr: "NY",
    capital: "Albany",
    bird: "Eastern Bluebird",
    flower: "Rose",
    statehoodYear: 1788,
    nickname: "The Empire State",
    isOpenEd: false,
    flagPalette: ["#003F87", "#FFD700", "#FFFFFF"],
    path: "M899.3,195.7L900.8,194.4L899.3,195.7ZM868.9,217.2L866.6,221.4L868.9,217.2ZM767.5,200.3L780.3,186.1L774.8,176.0L783.8,171.7L795.8,170.3L799.8,171.9L811.4,167.8L819.6,159.9L816.9,154.4L819.3,152.5L814.7,150.3L815.0,146.4L828.6,127.9L834.4,123.1L857.6,117.8L863.9,149.7L865.6,148.3L867.1,150.3L871.0,167.6L870.6,183.2L875.7,202.6L872.3,206.0L874.1,208.3L872.2,212.0L890.9,204.2L896.5,198.7L895.6,200.6L899.5,201.8L903.1,198.9L885.7,213.0L871.7,219.3L869.2,216.4L870.1,209.0L849.7,202.4L846.3,195.3L840.9,192.1L768.6,206.4L767.5,200.3Z",
  },
  {
    name: "North Carolina",
    abbr: "NC",
    capital: "Raleigh",
    bird: "Northern Cardinal",
    flower: "Flowering Dogwood",
    statehoodYear: 1789,
    nickname: "The Tar Heel State",
    isOpenEd: false,
    flagPalette: ["#C8102E", "#FFFFFF", "#003F87"],
    path: "M864.3,329.1L866.8,331.4L864.3,329.1ZM863.3,349.7L870.9,343.2L868.6,332.1L871.3,344.1L863.3,349.7ZM755.5,334.0L794.2,328.7L858.8,315.9L868.4,331.7L856.8,316.9L862.3,326.4L859.3,323.0L860.0,324.7L854.4,322.8L857.3,325.6L853.3,325.7L854.8,327.4L850.1,326.4L853.3,327.6L848.7,330.8L845.5,325.1L847.4,332.7L858.0,329.2L859.9,336.6L861.9,328.7L865.7,336.1L859.7,344.3L853.4,344.7L850.9,342.0L853.1,340.5L850.1,342.1L851.6,344.7L843.0,343.4L854.2,347.1L849.6,355.0L846.2,354.7L850.5,355.8L855.0,351.4L858.7,352.1L855.9,360.3L853.7,358.3L853.1,360.2L856.1,360.9L862.9,350.0L856.1,362.4L853.1,360.6L846.8,362.6L838.0,370.5L833.4,384.1L822.8,386.1L798.1,368.4L777.6,371.5L777.5,368.8L774.1,365.4L772.4,367.1L772.0,364.7L747.2,367.0L734.9,373.7L712.7,376.8L712.6,371.4L717.3,369.2L719.2,363.8L734.6,355.9L735.7,351.7L740.1,348.3L741.8,350.7L746.1,345.9L750.7,345.5L752.4,341.1L755.7,339.8L755.5,334.0Z",
  },
  {
    name: "North Dakota",
    abbr: "ND",
    capital: "Bismarck",
    bird: "Western Meadowlark",
    flower: "Wild Prairie Rose",
    statehoodYear: 1889,
    nickname: "The Peace Garden State",
    isOpenEd: true,
    flagPalette: ["#003F87", "#FFD700"],
    path: "M376.9,65.7L479.5,70.7L481.4,77.7L480.5,89.4L484.9,102.5L485.5,123.3L489.1,139.9L371.1,134.3L376.9,65.7Z",
  },
  {
    name: "Ohio",
    abbr: "OH",
    capital: "Columbus",
    bird: "Northern Cardinal",
    flower: "Scarlet Carnation",
    statehoodYear: 1803,
    nickname: "The Buckeye State",
    isOpenEd: false,
    flagPalette: ["#C8102E", "#FFFFFF", "#003F87"],
    path: "M685.8,225.4L708.3,221.7L717.6,225.5L719.0,223.6L725.6,227.4L737.5,223.2L744.2,215.9L756.1,209.0L761.1,239.2L758.9,241.0L760.9,246.6L758.8,263.0L753.7,269.4L749.8,269.4L746.4,273.1L744.6,277.8L746.0,281.3L744.0,282.7L741.4,279.5L740.2,281.0L737.9,293.5L733.2,294.8L727.0,287.9L720.6,292.4L716.2,290.6L713.9,292.7L703.9,289.8L698.5,283.2L692.5,284.3L685.8,225.4Z",
  },
  {
    name: "Oklahoma",
    abbr: "OK",
    capital: "Oklahoma City",
    bird: "Scissor-tailed Flycatcher",
    flower: "Oklahoma Rose",
    statehoodYear: 1907,
    nickname: "The Sooner State",
    isOpenEd: true,
    flagPalette: ["#5B7BBE", "#FFFFFF", "#C8102E"],
    path: "M372.5,339.4L443.3,343.1L522.8,343.8L526.8,380.5L526.4,420.7L512.4,413.5L511.4,415.4L496.1,416.1L491.6,419.8L487.1,415.2L483.8,416.6L479.4,413.7L476.1,418.5L475.4,414.4L471.3,416.6L466.5,412.7L463.1,415.8L458.5,408.7L451.7,410.6L438.7,406.8L435.3,401.1L434.9,402.9L429.4,402.6L423.9,398.3L425.8,353.9L371.6,350.8L372.5,339.4Z",
  },
  {
    name: "Oregon",
    abbr: "OR",
    capital: "Salem",
    bird: "Western Meadowlark",
    flower: "Oregon Grape",
    statehoodYear: 1859,
    nickname: "The Beaver State",
    isOpenEd: true,
    flagPalette: ["#003F87", "#FFD700"],
    path: "M71.0,70.2L79.5,76.9L79.0,86.8L84.9,91.1L93.8,89.9L101.1,91.9L102.8,94.7L112.0,93.9L115.3,95.9L138.7,94.8L170.5,102.4L175.0,109.0L175.7,112.3L157.4,136.6L161.7,143.3L157.9,150.5L148.9,190.7L83.7,174.8L31.6,158.4L32.8,139.9L45.4,120.7L58.3,89.6L63.8,68.9L65.7,71.1L71.0,70.2Z",
  },
  {
    name: "Pennsylvania",
    abbr: "PA",
    capital: "Harrisburg",
    bird: "Ruffed Grouse",
    flower: "Mountain Laurel",
    statehoodYear: 1787,
    nickname: "The Keystone State",
    isOpenEd: false,
    flagPalette: ["#003F87", "#FFD700"],
    path: "M756.1,209.0L767.5,200.3L768.6,206.4L840.9,192.1L846.3,195.3L849.7,202.4L855.0,204.0L849.6,213.8L851.5,216.1L849.9,220.8L860.6,230.8L854.8,238.7L844.9,244.6L764.5,259.9L756.1,209.0Z",
  },
  {
    name: "Rhode Island",
    abbr: "RI",
    capital: "Providence",
    bird: "Rhode Island Red",
    flower: "Violet",
    statehoodYear: 1790,
    nickname: "The Ocean State",
    isOpenEd: false,
    flagPalette: ["#FFFFFF", "#FFD700", "#003F87"],
    path: "M910.5,182.8L912.8,186.4L911.8,187.6L910.5,184.0L909.1,188.3L910.5,182.8ZM908.4,188.4L908.5,186.1L908.4,188.4ZM906.7,196.0L907.0,194.3L906.7,196.0ZM901.7,193.5L898.8,178.0L905.5,176.0L909.9,183.0L906.7,181.2L907.6,190.7L901.7,193.5Z",
  },
  {
    name: "South Carolina",
    abbr: "SC",
    capital: "Columbia",
    bird: "Carolina Wren",
    flower: "Yellow Jessamine",
    statehoodYear: 1788,
    nickname: "The Palmetto State",
    isOpenEd: false,
    flagPalette: ["#003F87", "#FFFFFF"],
    path: "M734.9,373.7L747.2,367.0L772.0,364.7L772.4,367.1L774.1,365.4L777.5,368.8L777.6,371.5L798.1,368.4L822.8,386.1L816.3,392.2L811.0,407.9L806.9,408.6L807.4,410.8L802.1,414.5L800.6,419.0L792.2,422.9L793.0,426.9L790.0,428.8L788.3,427.5L789.5,429.8L785.3,434.5L781.4,433.4L778.7,425.8L774.0,422.7L771.3,414.4L748.3,396.2L741.1,385.4L731.7,381.5L734.9,373.7Z",
  },
  {
    name: "South Dakota",
    abbr: "SD",
    capital: "Pierre",
    bird: "Ring-necked Pheasant",
    flower: "Pasque Flower",
    statehoodYear: 1889,
    nickname: "The Mount Rushmore State",
    isOpenEd: false,
    flagPalette: ["#5B9BD5", "#FFD700"],
    path: "M369.1,155.7L371.1,134.3L489.1,139.9L484.4,147.3L490.8,154.3L490.6,195.2L488.2,195.2L490.8,203.9L487.5,211.9L490.6,218.3L477.9,210.1L467.8,209.4L464.3,211.7L456.8,206.2L365.3,201.0L369.1,155.7Z",
  },
  {
    name: "Tennessee",
    abbr: "TN",
    capital: "Nashville",
    bird: "Northern Mockingbird",
    flower: "Iris",
    statehoodYear: 1796,
    nickname: "The Volunteer State",
    isOpenEd: false,
    flagPalette: ["#C8102E", "#FFFFFF", "#003F87"],
    path: "M611.9,363.1L614.2,360.1L612.2,357.3L615.1,356.7L614.7,351.5L641.4,349.5L640.8,345.4L704.2,340.8L756.0,333.4L755.7,339.8L752.4,341.1L750.7,345.5L746.1,345.9L741.8,350.7L740.1,348.3L735.7,351.7L734.6,355.9L719.2,363.8L717.3,369.2L712.6,371.4L712.7,376.8L602.8,386.7L607.1,383.2L604.8,376.8L606.9,377.1L607.0,373.8L609.2,374.5L608.4,369.4L613.7,365.2L611.9,363.1Z",
  },
  {
    name: "Texas",
    abbr: "TX",
    capital: "Austin",
    bird: "Northern Mockingbird",
    flower: "Bluebonnet",
    statehoodYear: 1845,
    nickname: "The Lone Star State",
    isOpenEd: true,
    flagPalette: ["#003F87", "#FFFFFF", "#C8102E"],
    path: "M371.6,350.8L425.8,353.9L423.9,398.3L429.4,402.6L434.9,402.9L435.3,401.1L438.7,406.8L451.7,410.6L458.5,408.7L460.9,414.6L463.1,415.8L467.5,412.8L472.3,416.6L475.4,414.4L477.5,418.8L479.4,413.7L483.8,416.6L487.1,415.2L491.6,419.8L496.1,416.1L511.4,415.4L512.4,413.5L528.8,422.8L534.8,422.5L535.5,457.9L539.8,463.0L539.6,467.0L546.1,479.9L542.1,491.0L543.1,502.1L538.9,507.5L540.6,510.6L522.2,518.2L527.7,514.4L522.1,514.3L522.5,508.6L518.4,510.5L517.4,513.8L519.9,519.4L514.6,523.9L523.1,518.8L510.3,529.5L492.0,539.2L477.8,551.1L470.0,570.2L474.2,592.2L470.1,581.5L470.4,563.6L476.2,551.0L489.0,539.7L484.3,542.0L482.5,539.9L479.3,546.3L477.2,544.8L473.6,547.0L477.4,546.5L474.1,553.0L468.0,551.5L472.7,555.8L469.4,564.3L467.4,565.3L467.3,563.3L465.0,566.0L469.2,565.7L468.5,580.3L474.4,595.1L469.7,597.6L464.1,593.5L451.8,592.1L440.1,585.1L434.9,584.3L427.9,569.9L427.1,557.7L419.9,552.1L419.0,548.0L412.0,540.8L405.1,521.7L391.5,506.3L373.4,502.6L372.4,504.9L366.4,505.5L362.0,516.1L356.8,521.6L350.7,519.8L331.3,505.3L324.4,481.9L315.8,475.4L294.9,450.9L295.1,447.0L362.9,453.3L371.6,350.8Z",
  },
  {
    name: "Utah",
    abbr: "UT",
    capital: "Salt Lake City",
    bird: "California Gull",
    flower: "Sego Lily",
    statehoodYear: 1896,
    nickname: "The Beehive State",
    isOpenEd: true,
    flagPalette: ["#003F87", "#FFD700"],
    path: "M197.7,201.1L247.2,209.6L243.5,232.2L277.1,237.2L264.6,328.0L176.0,313.3L197.7,201.1Z",
  },
  {
    name: "Vermont",
    abbr: "VT",
    capital: "Montpelier",
    bird: "Hermit Thrush",
    flower: "Red Clover",
    statehoodYear: 1791,
    nickname: "The Green Mountain State",
    isOpenEd: false,
    flagPalette: ["#003F87", "#FFD700"],
    path: "M857.6,117.8L886.1,110.5L887.9,122.1L881.8,127.9L883.1,133.0L880.6,145.8L881.7,161.7L884.1,164.8L870.3,166.5L867.1,150.3L865.6,148.3L863.9,149.7L857.6,117.8Z",
  },
  {
    name: "Virginia",
    abbr: "VA",
    capital: "Richmond",
    bird: "Northern Cardinal",
    flower: "American Dogwood",
    statehoodYear: 1788,
    nickname: "The Old Dominion",
    isOpenEd: false,
    flagPalette: ["#003F87", "#FFFFFF"],
    path: "M855.5,283.8L862.5,280.5L854.2,304.2L852.6,296.6L855.5,283.8ZM747.1,313.2L748.2,316.7L753.4,320.1L758.5,316.2L761.3,318.1L766.7,315.4L767.0,312.7L768.8,313.7L776.6,309.3L776.0,305.1L783.8,282.9L790.3,285.9L794.0,275.0L796.6,276.6L802.9,266.0L802.6,259.1L812.9,264.9L813.9,260.3L816.6,260.2L818.2,264.2L826.9,267.6L828.2,271.6L825.1,274.0L825.8,280.9L829.6,278.7L831.9,282.6L838.2,282.9L845.9,287.3L845.1,294.0L833.9,287.2L842.2,294.6L846.4,294.9L848.0,300.4L845.1,298.9L846.9,301.5L844.5,302.6L848.6,304.6L849.0,307.5L847.3,308.7L841.9,303.8L836.6,304.6L841.3,304.4L846.3,310.5L854.4,308.0L858.8,315.9L780.3,331.1L719.8,338.7L729.0,334.2L735.2,324.6L747.1,313.2Z",
  },
  {
    name: "Washington",
    abbr: "WA",
    capital: "Olympia",
    bird: "American Goldfinch",
    flower: "Coast Rhododendron",
    statehoodYear: 1889,
    nickname: "The Evergreen State",
    isOpenEd: true,
    flagPalette: ["#2D6E4E", "#FFD700"],
    path: "M93.2,50.9L94.9,47.8L95.7,50.9L93.2,50.9ZM98.9,20.3L100.0,22.7L98.9,20.3ZM95.0,31.0L98.5,27.7L99.3,30.6L95.8,31.6L97.1,36.6L98.3,35.1L99.6,36.9L98.7,39.7L95.0,31.0ZM95.5,17.9L97.5,19.7L95.5,17.9ZM91.0,21.2L94.0,22.9L95.9,19.9L98.1,21.8L95.6,26.6L91.0,21.2ZM91.1,19.1L92.7,20.8L91.1,19.1ZM183.6,35.9L170.1,94.1L170.5,102.4L138.7,94.8L115.3,95.9L112.0,93.9L102.8,94.7L101.1,91.9L93.8,89.9L84.9,91.1L79.0,86.8L80.1,80.0L77.0,73.8L63.0,67.6L65.5,59.8L65.6,65.8L69.7,59.0L65.9,57.2L66.3,53.6L70.7,53.9L67.5,50.7L65.8,52.9L67.4,19.1L76.9,27.1L88.9,30.7L92.0,35.6L94.6,32.9L95.3,39.1L91.0,42.7L91.1,40.4L83.8,48.2L87.7,48.6L84.6,47.6L96.6,39.0L92.4,52.4L91.2,53.6L90.1,50.6L89.1,55.2L89.1,50.1L87.6,51.3L89.4,55.7L92.8,51.7L96.1,51.9L96.5,44.8L101.5,38.7L100.5,32.6L100.0,36.3L98.2,34.1L100.9,30.4L97.5,26.4L100.9,27.0L102.4,24.4L101.9,20.2L99.6,20.5L100.0,14.4L183.6,35.9Z",
  },
  {
    name: "West Virginia",
    abbr: "WV",
    capital: "Charleston",
    bird: "Northern Cardinal",
    flower: "Rhododendron",
    statehoodYear: 1863,
    nickname: "The Mountain State",
    isOpenEd: false,
    flagPalette: ["#FFFFFF", "#003F87"],
    path: "M733.2,294.8L737.9,293.5L741.4,279.5L744.0,282.7L746.0,281.3L744.6,277.8L746.4,273.1L749.8,269.4L753.7,269.4L758.8,263.0L760.9,246.6L758.9,241.0L761.1,239.2L764.5,259.9L782.3,256.9L784.1,268.5L789.7,261.4L792.3,261.6L794.2,256.7L800.4,258.3L804.5,253.4L810.8,254.4L813.9,260.3L812.9,264.9L802.6,259.1L802.9,266.0L796.6,276.6L794.0,275.0L790.3,285.9L783.8,282.9L776.0,305.1L776.6,309.3L768.8,313.7L767.0,312.7L766.7,315.4L761.3,318.1L758.5,316.2L753.4,320.1L748.2,316.7L747.9,313.7L740.9,311.1L733.2,300.7L733.2,294.8Z",
  },
  {
    name: "Wisconsin",
    abbr: "WI",
    capital: "Madison",
    bird: "American Robin",
    flower: "Wood Violet",
    statehoodYear: 1848,
    nickname: "The Badger State",
    isOpenEd: false,
    flagPalette: ["#003F87", "#FFD700"],
    path: "M641.9,146.3L643.9,144.9L641.9,146.3ZM584.0,113.3L585.0,111.5L584.0,113.3ZM581.2,115.2L583.1,114.1L581.2,115.2ZM579.6,117.2L580.8,115.8L579.6,117.2ZM579.1,113.0L582.7,113.4L579.1,113.0ZM579.2,118.5L582.6,116.9L579.2,118.5ZM560.2,121.1L578.3,114.6L579.7,116.1L577.0,122.8L580.2,120.5L588.3,124.2L590.3,128.0L622.7,135.0L623.1,138.1L628.2,140.2L627.3,147.0L630.2,146.5L629.9,151.5L632.4,153.0L632.0,155.7L629.0,156.6L626.8,166.2L632.6,158.9L635.8,158.1L637.9,150.9L641.6,147.6L632.5,180.8L630.8,195.3L634.2,212.4L587.0,215.4L585.6,212.4L579.9,210.5L577.4,201.6L579.2,198.7L576.5,196.3L574.9,185.5L563.9,174.9L549.3,165.9L551.3,149.9L547.5,147.3L547.6,144.0L556.4,135.6L555.9,122.3L560.2,121.1Z",
  },
  {
    name: "Wyoming",
    abbr: "WY",
    capital: "Cheyenne",
    bird: "Western Meadowlark",
    flower: "Indian Paintbrush",
    statehoodYear: 1890,
    nickname: "The Equality State",
    isOpenEd: true,
    flagPalette: ["#FFFFFF", "#C8102E", "#003F87"],
    path: "M369.1,155.7L361.4,246.5L243.5,232.2L257.8,142.0L369.1,155.7Z",
  },
];

export const OPENED_STATE_ABBRS = ["AR", "CO", "IA", "IN", "KS", "MN", "MT", "ND", "NV", "OK", "OR", "TX", "UT", "WA", "WY"];

export const STATES_BY_ABBR = Object.fromEntries(STATES.map(s => [s.abbr, s]));

export const OPENED_STATES = STATES.filter(s => s.isOpenEd);